import {
    AdminListMembersResult,
    InviteMemberInput,
    InviteMemberResult,
    RegisterMemberInput,
    RegisterMemberResult,
    ReinviteMembersInput,
    ReinviteMembersResult,
    ToggleActiveStatusInput,
    ToggleActiveStatusResult,
    UpdateAdminStatusInput,
    UpdateAdminStatusResult,
} from '@vivport/backend/types';
import { httpClient } from './http-client';

/**
 * Admin API
 * Type-safe wrappers for all admin operations
 * @requires Authentication (Admin only for most operations)
 */

// ============================================================================
// Member Management
// ============================================================================

/**
 * Register a new member directly
 */
export async function registerMember(input: RegisterMemberInput): Promise<RegisterMemberResult> {
  return httpClient.post<RegisterMemberResult, RegisterMemberInput>('/protected/admin/register', input);
}

/**
 * Send invitation to join hub
 * @requires Admin
 */
export async function inviteMember(input: InviteMemberInput): Promise<InviteMemberResult> {
  return httpClient.post<InviteMemberResult, InviteMemberInput>('/protected/admin/invite', input);
}

/**
 * Reinvite existing members (resend invitation email)
 * @requires Admin
 */
export async function reinviteMembers(input: ReinviteMembersInput): Promise<ReinviteMembersResult> {
  return httpClient.post<ReinviteMembersResult, ReinviteMembersInput>('/protected/admin/reinvite', input);
}

/**
 * Retrieve all members for the hub
 * @requires Admin
 */
export async function listMembers(): Promise<AdminListMembersResult> {
  return httpClient.get<AdminListMembersResult>('/protected/admin/list');
}

/**
 * Update admin status for selected members
 * @requires Admin
 */
export async function updateAdminStatus(input: UpdateAdminStatusInput): Promise<UpdateAdminStatusResult> {
  return httpClient.post<UpdateAdminStatusResult, UpdateAdminStatusInput>(
    '/protected/admin/update-admin-status',
    input
  );
}

/**
 * Toggle active status for selected members
 * @requires Admin
 */
export async function toggleActiveStatus(input: ToggleActiveStatusInput): Promise<ToggleActiveStatusResult> {
  return httpClient.post<ToggleActiveStatusResult, ToggleActiveStatusInput>(
    '/protected/admin/toggle-active-status',
    input
  );
}

